import { Component, Input, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-form-details',
  templateUrl: './form-details.component.html',
  styleUrls: ['./form-details.component.scss'],
})
export class FormDetailsComponent implements OnInit {
  @Input() id
  form
  constructor(
    private dataSRV:DataService
  ) { }

  ngOnInit() {
    this.dataSRV.getData('api/v1/user/forms/{{}}').subscribe(d=>{
      this.form=d
      
    })
  }

}
